export enum AccountsFilterPropertyNames {
  Name = "name",
  AccountTypeName = "accountTypeName",
  Added = "added",
}
